import React from "react";
import RoomBloc from "../../blocs/RoomBloc";
import BlocBuilder from "bloc-builder-react";

import { TutorialStep } from "../../models/TutorialState";
import RoomTopActions from "./RoomTopActions";
import TapToCloseArea from "./TapToCloseArea";
import TutorialRoomOverlays from "./TutorialRoomOverlays";
import BottomModalState from "../../models/BottomModalState";
import SwipeScreen from "../../../SwipeScreen";
import $ from "jquery";
import $events from '../../blocs/EventBloc';
import mediumZoom from "medium-zoom";
import BottomModal from "../BottomModal/BottomModal";
import InfoSpot from "../InfoSpot";
import MuseumRoom from "../MuseumRoom/MuseumRoom";

export default class RoomComponent extends React.Component {
    constructor( props ) {
        super(props);

        this.bloc           = new RoomBloc(this.props.storylineState);
        this.swipeScreenRef = React.createRef();
        this.mediumZoom     = null;
        this.SwipeScreen    = null;

        this.state = { currentState: null };
    }

    componentDidMount() {
        $events.$on('tutorial/start', () => {
            let isStatic = !( this.SwipeScreen?.aspectRatioIsSwipeable() ?? true );
            this.bloc.startTutorial(isStatic);

            if ( isStatic ) {
                setTimeout(() => {
                    $events.$emit('swipescreen/pan');
                    $events.$emit('swipescreen/detectInfospots');
                }, 100);
            }
        });

        $events.$on('swipescreen/pan', () => {
            let currentState = this.bloc.getSubject().value;
            if ( currentState.tutorialState.currentStep !== TutorialStep.Step1 ) {
                return;
            }

            this.bloc.markSwipeAsLearned();
        });

        $events.$on('room/startInitialTimer', () => {
            this.bloc.startInitialTimer();
        });

        $events.$on('room/cancelInitialTimer', () => {
            this.bloc.cancelInitialTimer();
        });

        $events.$on('bottomModal/close', () => {
            let currentState = this.bloc.getSubject().value;

            if ( currentState.tutorialState.forceShowTutorial === true && currentState.tutorialState.currentStep === TutorialStep.Start ) {
                this.bloc.currentState.tutorialState.nextStep();
                this.bloc.pushState();
            }
        });

        $events.$on('infoSpot/tap', () => {
            let currentState = this.bloc.getSubject().value;

            if ( currentState.tutorialState.forceShowTutorial === true && currentState.tutorialState.currentStep === TutorialStep.Step1 ) {
                this.bloc.currentState.tutorialState.finish();
                this.bloc.pushState();
            }
        });

        this.bloc.getSubject().asObservable().subscribe(( state ) => {
            // console.log("roomBloc state updated");
            // console.log(state);
            this.setState({
                currentState: state
            });
        });

        // this.SwipeScreen = new SwipeScreen($(this.swipeScreenRef.current));

        this.bloc.showDefaultRoomContent();
        this.bloc.startInitialTimer();
    }

    componentWillUnmount() {
        $events.$off('tutorial/start');
        $events.$off('swipescreen/pan');
        $events.$off('bottomModal/close');
        $events.$off('infoSpot/tap');
    }

    componentDidUpdate( prevProps, prevState, snapshot ) {
        if ( this.mediumZoom !== null ) {
            // this.mediumZoom.off('open', this.createPinchZoom);
            this.mediumZoom.detach();
        }
        if ( this.SwipeScreen !== null ) this.SwipeScreen.destroy();

        this.SwipeScreen = new SwipeScreen($(this.swipeScreenRef.current));

        const lightboxExtensions = [
            'jpg', 'jpeg', 'png', 'gif', 'webp',
        ];

        const selector = lightboxExtensions.map(ext => `.wp-block-gallery a[href$=".${ext}"] img`).join(', ');

        this.mediumZoom = mediumZoom(selector, {
            margin: 20,
            background: 'rgba(255, 255, 255, .9)',
        });
        // this.mediumZoom.on('open', this.createPinchZoom);
    }

    createPinchZoom = ( event ) => {
        setTimeout(() => {
            // new PinchZoom($('.medium-zoom-image--opened')[0]);
        }, 1000);
    };

    selectInfoSpot = ( e, spot ) => {
        e.preventDefault();
        e.stopPropagation();

        $events.$emit('infoSpot/tap');

        this.bloc.selectInfoSpot(spot);
    };

    onBackgroundTap = ( e ) => {
        e.preventDefault();
        e.stopPropagation();

        $events.$emit('bottomModal/close');
        this.bloc.onBackgroundTap();
    };

    onRoomOverviewTap = ( e ) => {
        e.preventDefault();
        e.stopPropagation();

        this.bloc.onRoomOverviewTap();
    };

    onHelpTap = ( e ) => {
        e.preventDefault();
        e.stopPropagation();

        this.bloc.onHelpTap();
    };

    render() {
        let roomState = this.state.currentState;

        if ( roomState == null ) {
            return <></>;
        }

        let isStatic = $(this.swipeScreenRef.current).hasClass('swipe-screen--static') ?? false;
        if ( isStatic ) {
            // console.log("keeps static");
        }
        let swipeStatic = isStatic || !( this.SwipeScreen?.aspectRatioIsSwipeable() ?? true );

        return <div className="h--100">
            <div
                className={`swipe-screen  [ room-screen ]  [ js-swipe-screen ] ${this.bloc.getRoomClasses(roomState)}  ${( isStatic ) ? 'swipe-screen--static' : ''}`}
                ref={this.swipeScreenRef}
                id={`swipe-screen-${( roomState?.room?.id ?? 0 )}`}
                data-static-mode="center"
            >

                <RoomTopActions
                    onRoomOverviewTap={this.onRoomOverviewTap}
                    onHelpTap={this.onHelpTap}>
                </RoomTopActions>

                <TapToCloseArea/>

                {( ( roomState?.room?.isTutorialRoom ?? false ) || ( roomState?.tutorialState?.forceShowTutorial ?? false ) ) &&
                <TutorialRoomOverlays roomState={roomState} isStatic={swipeStatic}/>}

                <div className="swipe-screen__background-container  [ js-swipe-screen-bg ]"
                     data-offset-x="0" data-offset-y="0"
                     onClick={this.onBackgroundTap}>

                    <div className="swipe-screen__background">
                        <div className="swipe-screen__image">
                            <img src={( roomState?.room?.thumbnailUrl ?? '' )} alt={( roomState?.room?.title ?? '' )}/>
                        </div>

                        <div className="swipe-screen__spots">
                            {roomState?.room?.spots?.map(( spot, i ) =>
                                <InfoSpot
                                    spot={spot}
                                    selectInfoSpot={this.selectInfoSpot}
                                    i={i}
                                    key={i}>
                                </InfoSpot>
                            )}
                        </div>
                    </div>
                </div>

                <div className="swipe-screen__foreground  [ room__foreground ]">
                    {( typeof roomState?.bottomModalState !== "undefined" ) &&
                    <BottomModal ref="bottomModal"
                                 currentState={roomState?.bottomModalState}
                                 tutorialState={roomState?.tutorialState}
                                 roomBloc={this.bloc}>
                    </BottomModal>}
                </div>

            </div>

            {( roomState?.room?.isMuseumRoom ?? false ) &&
            <MuseumRoom roomState={roomState}
                        roomBloc={this.bloc}
                        onRoomOverviewTap={this.onRoomOverviewTap}
                        onHelpTap={this.onHelpTap}>
            </MuseumRoom>}
        </div>;
    }

}
